var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    "data-bbox": "55.28 38.51 89.44 122.979",
    viewBox: "55.28 38.51 89.44 122.979",
    height: 200,
    width: 200,
    xmlns: "http://www.w3.org/2000/svg",
    "data-type": "color",
    role: "presentation",
    "aria-hidden": "true",
    "aria-label": "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M135.403 161.489H64.597c-5.137 0-9.317-4.179-9.317-9.317V47.827c0-5.137 4.18-9.317 9.317-9.317h50.949c2.489 0 4.829.969 6.588 2.729l19.857 19.857a9.253 9.253 0 0 1 2.729 6.588v84.489c0 5.137-4.179 9.316-9.317 9.316zM64.597 42.237a5.596 5.596 0 0 0-5.59 5.59v104.346a5.597 5.597 0 0 0 5.59 5.59h70.806a5.596 5.596 0 0 0 5.59-5.59V67.684a5.554 5.554 0 0 0-1.637-3.953l-19.857-19.857a5.558 5.558 0 0 0-3.953-1.637H64.597z",
    fill: "#fff",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.856 66.46h-16.769c-5.137 0-9.317-4.179-9.317-9.317v-16.77h3.727v16.77a5.597 5.597 0 0 0 5.59 5.59h16.769v3.727z",
    fill: "#fff",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.559 123.283H72.493l18.441-31.94 11.448 15.25 7.59-8.575 14.587 25.265zm-45.611-3.726h39.156l-8.771-15.193-7.188 8.121L91.34 98.092l-12.392 21.465z",
    fill: "#fff",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.886 96.581c-4.708 0-8.539-3.831-8.539-8.539s3.831-8.539 8.539-8.539 8.539 3.831 8.539 8.539-3.831 8.539-8.539 8.539zm0-13.351c-2.653 0-4.812 2.159-4.812 4.812s2.159 4.812 4.812 4.812c2.653 0 4.812-2.159 4.812-4.812s-2.159-4.812-4.812-4.812z",
    fill: "#fff",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M124.612 128.882v1.863H72.439v-1.863h52.173z",
    "data-color": 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.c75029d639880805dc99d40dfa745e0b.svg";
export { ForwardRef as ReactComponent };